import React from "react";

const Report = () => {
  return (
    <section>
      <div className="container">
        {/* <div className="html2pdf__page-break"></div> */}
        <h3>Using the Report </h3>
        <p>
          The Empathy Index Report is designed to give you an insight into your
          Empathy Quotient along five empathy dimensions. Each dimension was
          subject to self-evaluation on eight survey items that capture the most
          conspicuous behaviours and belief systems. Your responses have been
          indexed on a five point ‘Frequency Scale’ as under:-
        </p>
        <div>
          <p className="ml-2">1. Never</p>
          <p className="ml-2">2. Rarely</p>
          <p className="ml-2">3. Seldom</p>
          <p className="ml-2">4. Often</p>
          <p className="ml-2">5. Always</p>
        </div>
        <p>
          The purpose of the scale is not to test your awareness; whether you
          know or do not know a particular dimension, but to give you a chance
          to self-evaluate the frequency with which you bring these behaviours
          into a conscious realm of application.
        </p>
        <p>
          Below graphic exhibits a visual depiction of how well, or
          inadequately, you have fared on five fundamental dimensions of Empathy
          Index. Your scores will broadly determine your ability to exercise
          empathy and gain a critical insight into others’ world (customers and
          stakeholders) and the barriers that you will do well to overcome,
          through structured reflections and translating your insights into
          behaviours on ground.
        </p>
        <p>
          Having a better understanding of our own empathetic quotient, enables
          us to reframe and realign our thought processes to meet the empathy
          needs of others.
        </p>
        <p>Hope you enjoy your report as much as we enjoyed creating it.</p>
      </div>
    </section>
  );
};

export default Report;
